import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  Tooltip,
  IconButton,
  Popover,
  LinearProgress,
} from "@mui/material";
import { BASE_URL } from "../../constants";
import { toast } from "react-toastify";
import PatientRegForm from "../PatientManagement/PatientRegForm";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import { useNavigate } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
const RefPatientList = () => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [patRegOpen, setPatRegOpen] = useState(false);
  const [registered, setRegistered] = useState(false);
  const fetchPatients = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}api/user/common/centre-refs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.success) {
        setPatients(data.data);
      } else {
        setError(data.message || "Failed to fetch patients");
      }
    } catch (err) {
      setError("Error fetching patients");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  const [loadingStatus, setLoadingStatus] = useState(false);

  // 🔹 Dialog state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null); // "approved" or "rejected"
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [selectedPatientName, setSelectedPatientName] = useState(null);
  const [selectedPatientForReg, setSelectedPatientForReg] = useState(null);
  const [registeredPatientData, setRegisteredPatientData] = useState(null);

  const handleOpenConfirm = (action, patient) => {
    setSelectedAction(action);
    setSelectedPatientId(patient._id);
    setSelectedPatientName(patient.patientName);
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
    // setSelectedAction(null);
    // setSelectedPatientId(null);
  };

  const updateStatus = async (newStatus, patientId) => {
    setLoadingStatus(true);
    try {
      const res = await fetch(
        `${BASE_URL}api/user/common/ref-patient-status/${patientId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ status: newStatus }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        toast.success(`Status updated to ${data.data.status}`);

        // 🔥 Immediately update local state
        setPatients((prev) =>
          prev.map((p) =>
            p._id === patientId ? { ...p, status: data.data.status } : p,
          ),
        );
        if (data.data.status === "approved") {
          setPatRegOpen(true);
          setSelectedPatientForReg(data?.data);
        }
      } else {
        toast.error(data.message || "Failed to update status");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setLoadingStatus(false);
      handleCloseConfirm();
    }
  };

  useEffect(() => {
    if (registered) {
      setPatients((prev) =>
        prev.map((p) =>
          p._id === selectedPatientForReg?._id
            ? { ...p, registered: true, patientID: registeredPatientData }
            : p,
        ),
      );
      setPatRegOpen(false);
    }
  }, [registered]);

  const filteredPatients = patients.filter((p) =>
    p.patientName.toLowerCase().includes(search.toLowerCase()),
  );

  const handleReg = (pat) => {
    setPatRegOpen(true);
    setSelectedPatientForReg(pat);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const handleOpenPopover = (event, patient) => {
    setAnchorEl(event.currentTarget);
    setSelectedPatient(patient);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setSelectedPatient(null);
  };

  const open = Boolean(anchorEl);

  const navigate = useNavigate();
  const sendToOpd = (patient) => {
    console.log("PPP", patient);
    const data = {
      centre: patient?.centreId || null,
      doctor: patient?.doctor || null,
      patient: patient?.patientID || null,
    };
    navigate("/dashboard/opd", {
      state: { ...data, fromCentreRef: true, isEdit: false },
    });
  };
  const sendToBill = (patient) => {
    console.log("PPP", patient);
    const invoice = {
      center: patient?.centreId || null,
      doctor: patient?.doctor || null,
      patient: patient?.patientID || null,
      fromCentreRef: true,
    };
    navigate("/dashboard/bills", { state: { invoice } });
  };

  // if (loading) {
  //   return (
  //     <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // if (error) {
  //   return (
  //     <Typography color="error" align="center" mt={4}>
  //       {error}
  //     </Typography>
  //   );
  // }

  return (
    <Box width="100%">
      {/* 🔍 Search Input */}
      <Alert sx={{ mb: 2 }} severity="info">
        Referred patients will be permanently removed from the server after
        their visiting date. Please ensure that all necessary actions like
        APPROVE, REJECT and REGISTER are completed before the visiting date.
      </Alert>
      <TableContainer
        component={Paper}
        elevation={3}
        sx={{ borderRadius: "16px" }}
      >
        <Box display="flex" justifyContent="space-between" mt={1} mb={1}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#f0fdf4", // tailwind: bg-green-50
              borderRadius: "5px",
              border: "1px solid #bbf7d0", // tailwind: border-green-200
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              maxHeight: 36,
              p: 1,
              mx: 1,
            }}
          >
            {patients.length}
            <Typography
              sx={{
                color: "#166534", // tailwind: text-green-800
                fontSize: "0.875rem", // text-sm
                fontWeight: 500,
              }}
            >
              {" " + "Referrals"}
            </Typography>
          </Box>
          <Box>
            <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <IconButton color="primary" onClick={fetchPatients}>
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>
        <Table>
          <TableHead sx={{ backgroundColor: "#f3f4f6" }}>
            <TableRow>
              {[
                "Ref. By",
                "Visiting Date",
                "Patient Name",
                "Age",
                "Sex",
                "Phone",
                "Doctor",
                "Action",
              ].map((head) => (
                <TableCell key={head}>{head}</TableCell>
              ))}
            </TableRow>
            {loading && (
              <TableRow>
                <TableCell colSpan={8} sx={{ padding: 0 }}>
                  <LinearProgress
                    color="success"
                    sx={{ height: 2, width: "100%" }}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableHead>

          <TableBody>
            {filteredPatients.length > 0
              ? filteredPatients.map((patient) => (
                  <TableRow key={patient._id}>
                    <TableCell>
                      <div>
                        <p>{patient.centreId.centreName}</p>
                        <p>{patient.centreId.centreId}</p>
                      </div>
                    </TableCell>
                    <TableCell>
                      {new Date(patient.visitingDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>{patient.patientName}</TableCell>
                    <TableCell>{patient.patientAge || "-"}</TableCell>
                    <TableCell>{patient.patientSex || "-"}</TableCell>
                    <TableCell>{patient.patientPhone || "-"}</TableCell>
                    <TableCell>{patient?.doctor?.name || "-"}</TableCell>
                    <TableCell>
                      <Box display="flex" gap={1}>
                        {!patient.status ? (
                          <>
                            <Button
                              size="small"
                              variant="contained"
                              sx={{ backgroundColor: "#22c55e" }}
                              onClick={() =>
                                handleOpenConfirm("approved", patient)
                              }
                              disabled={loadingStatus}
                            >
                              Approve
                            </Button>
                            <Button
                              size="small"
                              variant="contained"
                              sx={{ backgroundColor: "#ef4444" }}
                              onClick={() =>
                                handleOpenConfirm("rejected", patient)
                              }
                              disabled={loadingStatus}
                            >
                              Reject
                            </Button>
                          </>
                        ) : patient.status === "approved" ? (
                          <Tooltip
                            title={
                              patient.registered
                                ? "Approved and Registered"
                                : "Approved"
                            }
                          >
                            <IconButton>
                              {patient.registered ? (
                                <CheckCircleIcon color="success" />
                              ) : (
                                <TaskAltIcon color="success" />
                              )}
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Rejected">
                            <IconButton>
                              <NotInterestedIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {!patient.registered &&
                          patient?.status === "approved" && (
                            <Tooltip title="Register">
                              <IconButton onClick={() => handleReg(patient)}>
                                <PersonAddAltIcon color="primary" />
                              </IconButton>
                            </Tooltip>
                          )}
                        {patient.registered &&
                          patient?.status === "approved" && (
                            <Tooltip title="Send to">
                              <IconButton
                                onClick={(e) => handleOpenPopover(e, patient)}
                              >
                                <ContentPasteGoIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              : !loading && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No patients found
                    </TableCell>
                  </TableRow>
                )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Popover with 2 buttons */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              sendToOpd(selectedPatient);
            }}
          >
            OPD
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              sendToBill(selectedPatient);
            }}
          >
            BILL
          </Button>
        </Box>
      </Popover>

      {/* 🔹 Confirmation Dialog */}
      {/* 🔹 Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <Alert
            severity={selectedAction === "approved" ? "success" : "error"}
            sx={{ mb: 2 }}
          >
            Are you sure you want to{" "}
            <b>{selectedAction === "approved" ? "approve " : "reject "}</b>
            patient: <i>{selectedPatientName}</i>?
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={() => updateStatus(selectedAction, selectedPatientId)}
            color={selectedAction === "approved" ? "success" : "error"}
            disabled={loadingStatus}
            variant="contained"
          >
            {loadingStatus ? "Processing..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🔹 Input Dialog after Approval */}
      <Dialog
        open={patRegOpen}
        onClose={() => setPatRegOpen(false)}
        maxWidth="xs" // bigger than xs
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "80%", // adjust as needed
          },
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <Alert severity="info">
            Now you can register this patient in your Organization
          </Alert>
          <Button
            onClick={() => setPatRegOpen(false)}
            color="error"
            variant="outlined"
          >
            Cancel
          </Button>
        </DialogTitle>
        <DialogContent>
          <PatientRegForm
            patientRef={selectedPatientForReg}
            open={true}
            setRegistered={setRegistered}
            setRegisteredPatientData={setRegisteredPatientData}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RefPatientList;
